<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-[#f5f6f8] p-4 sm:p-8">
    <div class="duplicate-tab-container">
      <div class="flex justify-center mb-6">
        <img :src="logo" alt="NemiPay" class="h-20 w-auto object-contain" />
      </div>

      <div class="bg-white rounded-lg p-4 sm:p-5 shadow-[0_2px_12px_rgba(0,0,0,0.06)] text-center min-w-0">
        <div class="flex justify-center mb-4">
          <svg
            class="w-20 h-20 shrink-0"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="8"
              y="12"
              width="32"
              height="40"
              rx="4"
              stroke="#004AAD"
              stroke-width="2"
              fill="none"
            />
            <rect
              x="24"
              y="20"
              width="32"
              height="40"
              rx="4"
              stroke="#004AAD"
              stroke-width="2"
              fill="rgba(0, 74, 173, 0.06)"
            />
            <line
              x1="8"
              y1="24"
              x2="40"
              y2="24"
              stroke="#004AAD"
              stroke-width="1.5"
              stroke-opacity="0.6"
            />
            <line
              x1="24"
              y1="32"
              x2="56"
              y2="32"
              stroke="#004AAD"
              stroke-width="1.5"
              stroke-opacity="0.6"
            />
          </svg>
        </div>

        <h1 class="text-lg font-semibold mr-1 mb-2">
          {{ $t('duplicateTab.title') }}
        </h1>
        <p class="text-base sm:text-base text-[#495057] leading-6 mb-2 break-words">
          {{ $t('duplicateTab.description') }}
        </p>
        <p class="text-base sm:text-base text-[#6c757d] leading-6 mb-2 mt-3 break-words">
          {{ $t('duplicateTab.instruction') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DuplicateTabView',
  data() {
    return {
      logo: process.env.VUE_APP_NAVBAR_LOGO || process.env.VUE_APP_SIDEBAR_LOGO,
    };
  },
};
</script>

<style scoped>
.duplicate-tab-container {
  width: 100%;
  max-width: 450px;
}
@media (min-width: 640px) {
  .duplicate-tab-container {
    width: 450px;
  }
}
</style>
